/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useCallback, useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import StyledTableCell from '../../../../../../components/ui-elements/table/StyledTableCell';
import StyledTableRow from '../../../../../../components/ui-elements/table/StyledTableRow';
import { IconButton, Typography } from '@mui/material';
import { BsFillPencilFill } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import DialogContainer from '../../../../../../components/shared/Dialog/DialogContainer';
import DeviceEdit from './DeviceEdit';
import Loader from '../../../../../../components/ui-elements/loader'
import { FaHistory } from 'react-icons/fa';
import DeviceHistory from './DeviceHistory';
import { getAllDevice } from '../../../../../../store/reducers/device/deviceAction';
const DevicesList = () => {
    const [selectedDevice, setSelectedDevice] = useState({});
    const [openEditDevice, setOpenEditDevice] = useState(false);
    const [openHistoryDevice, setOpenHistoryDevice] = useState(false);
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch();
    const devices = useSelector(state => state.device.devices);

    const handleCloseDialog = () => {
        setOpenEditDevice(false);
        setOpenHistoryDevice(false);
    }
    const fetchDevices = useCallback(async () => {
        setLoading(true)
        try {
            await dispatch(getAllDevice()).unwrap();
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }, [dispatch]);

    useEffect(() => {
        fetchDevices()
    }, [fetchDevices])
    return (
        <>
            {!loading ? <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                    <TableHead>
                        <StyledTableRow>
                            <StyledTableCell label="Name" />
                            <StyledTableCell label="Owner" />
                            <StyledTableCell label="UID" />
                            <StyledTableCell label="Details" />
                            <StyledTableCell label=" " />

                        </StyledTableRow>
                    </TableHead>
                    <TableBody>
                        {devices?.Records?.length > 0 && devices.Records.map((row) => (
                            <StyledTableRow key={row.username}>
                                <StyledTableCell label={row.deviceName} />
                                <StyledTableCell label={row.deviceOwnerName} />
                                <StyledTableCell label={row.deviceUID} />

                                <StyledTableCell  >
                                    {row.deviceDetails.length > 0 ? <Typography style={{ fontWeight: 'bold' }} color={row.deviceDetails[0].detailValue === "true" ? 'primary' : 'error'}>
                                        {row.deviceDetails[0].detailValue === "true" ? 'Authorized' : 'Unauthorized'} </Typography> : "N/A"}
                                </StyledTableCell>
                                <StyledTableCell align="right"  >
                                    <IconButton color='primary' style={{ marginRight: '30px' }} onClick={() => { setSelectedDevice(row); setOpenEditDevice(true) }}>
                                        <BsFillPencilFill />
                                    </IconButton>
                                    <IconButton color='primary' style={{ marginRight: '30px' }} onClick={() => { setSelectedDevice(row); setOpenHistoryDevice(true) }}>
                                        <FaHistory />
                                    </IconButton>
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer> : (<Loader />)}

            <DialogContainer
                open={openEditDevice}
                handleClose={handleCloseDialog}
            >
                <DeviceEdit
                    selectedDevice={selectedDevice}
                    handleClose={handleCloseDialog} />
            </DialogContainer>

            <DialogContainer
                open={openHistoryDevice}
                handleClose={handleCloseDialog}
            >
                <DeviceHistory
                    selectedDevice={selectedDevice}
                    handleClose={handleCloseDialog} />
            </DialogContainer>
        </>
    )

}

 
export default DevicesList;